<template>
  <form @submit="editEmailNotification($event)">
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="email">Email</label>
          <input
            name="email"
            type="text"
            v-model="formData.email"
            placeholder="Enter email"
            class="form-control"
            v-validate="
              'required|email|regex:^([A-Za-z\\d]+[-_\.]?)+@([^\\s@])+\.([^\\s@])+$'
            "
            data-vv-as="email"
          />
          <div v-if="veeErrors.first('email')" class="invalid-feedback">
            {{ veeErrors.first("email") }}
          </div>
        </div>
      </div>
    </div>
    <div class="row submit-row">
      <div class="col d-flex">
        <div
          class="switch"
          @click="handleSwitchClick"
          :class="{ active: isActive === true }"
        >
          <div class="indicator"></div>
        </div>
        <span @click="handleSwitchClick">{{
          isActive ? "Active" : "Inactive"
        }}</span>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <div class="form-group">
          <label for="bookingNotif">Booking Notifications</label>
          <div>
            <label class="mr-3">
              <input
                class="mr-2"
                type="checkbox"
                v-model="formData.bookingNotif.makeBooking"
                name="make"
              />
              User make a booking
            </label>
            <label class="mr-3">
              <input
                class="mr-2"
                type="checkbox"
                v-model="formData.bookingNotif.notify"
                name="notify"
              />
              Notify 30 minutes before booking starts
            </label>
          </div>
          <div>
            <label class="mr-3">
              <input
                class="mr-2"
                type="checkbox"
                v-model="formData.bookingNotif.paid"
                name="paid"
              />
              Paid
            </label>
            <label class="mr-3">
              <input
                class="mr-2"
                type="checkbox"
                v-model="formData.bookingNotif.unpaid"
                name="unpaid"
              />
              Unpaid
            </label>
            <label class="mr-3">
              <input
                class="mr-2"
                type="checkbox"
                v-model="formData.bookingNotif.cancellation"
                name="cancellation"
              />
              Cancellation
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="bookingNotif">Locations</label>
          <div v-if="locations">
            <label
              class="mr-3"
              v-for="location in locations.data.data"
              :key="location.id"
            >
              <input
                type="checkbox"
                :name="location.name"
                v-model="formData.bookingNotif[location.name]"
                class="mr-2"
              />{{ location.name }}
            </label>
          </div>
          <Spinner :theme="primary" style="display: block;" v-else />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="bookingNotif">Categories</label>
          <div v-if="categories">
            <label
              class="mr-3"
              v-for="category in categories.data.data"
              :key="category.id"
            >
              <input
                type="checkbox"
                :name="category.name"
                v-model="formData.bookingNotif[category.name]"
                class="mr-2"
              />{{ category.name }}
            </label>
          </div>
          <Spinner :theme="primary" style="display: block;" v-else />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label class="mb-10">Private and Virtual Office Notification</label>
          <p>Notify before booking expires.</p>
          <label class="mr-3">
            <input
              type="checkbox"
              name="month"
              v-model="formData.bookingNotif.month"
              class="mr-2"
            />1 month
          </label>
          <label class="mr-3">
            <input
              type="checkbox"
              name="week"
              v-model="formData.bookingNotif.week"
              class="mr-2"
            />1 week
          </label>
          <label class="mr-3">
            <input
              type="checkbox"
              name="day"
              v-model="formData.bookingNotif.day"
              class="mr-2"
            />1 day
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label class="">Issues</label>
          <div>
            <label class="mr-3">
              <input
                type="checkbox"
                name="bug"
                class="mr-2"
                v-model="formData.bookingNotif.issue"
              />
              Report an issue
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label class="">Feedback</label>
          <div>
            <label class="mr-3">
              <input
                type="checkbox"
                name="bug"
                class="mr-2"
                v-model="formData.bookingNotif.feedback"
              />
              User Feedback
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-none">
      <div class="col">
        <div class="form-group">
          <label>Lead Notifications</label>
          <div>
            <label class="mr-3">
              <input type="checkbox" name="bookingNotif" class="mr-2" />1 month
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row submit-row ">
      <div class="col">
        <ActionButton
          type="submit"
          :theme="{ primary, secondary, event, danger }"
          label="Save"
          style="width: auto; margin-left: auto; margin-top: 0;"
          :disabled="loader"
        />
      </div>
    </div>
  </form>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import Spinner from "@/components/Spinner";
import axios from "@/helpers/axios";
import * as logger from "@/helpers/logger";

export default {
  name: "EditNotification",
  components: {
    ActionButton,
    Spinner
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formData: {
        id: this.user.id,
        email: this.user.email,
        bookingNotif: {}
      },
      locations: null,
      categories: null,
      isActive: false,
      loader: false
    };
  },
  mounted() {
    this.fetchResources({
      url: "locations",
      resource: "locations"
    });
    this.fetchResources({
      url: "categories",
      resource: "categories"
    });
  },
  created() {
    this.editSelectedEmailNotif();
  },
  methods: {
    fetchResources(params) {
      const { url, resource } = params;
      axios
        .get(url)
        .then(res => {
          resource === "locations"
            ? (this.locations = res)
            : (this.categories = res);
        })
        .catch(err => {
          logger.error(err);
        });
    },
    async editEmailNotification(event) {
      event.preventDefault();
      this.loader = true;
      let checkEmail = await axios.get(
        `/emailNotifications?email=${this.formData.email}`
      );
      try {
        let isFormValid = await this.$validator.validateAll();

        if (!isFormValid) {
          let errorMessage = !this.formData.email
            ? "Please fill the required field"
            : "Please fix all errors.";
          throw {
            type: "warning",
            title: "Warning",
            error: new Error(errorMessage)
          };
        }

        if (
          checkEmail.data.data[0] &&
          checkEmail.data.data[0].id != this.formData.id
        ) {
          throw {
            type: "warning",
            title: "Warning",
            error: new Error("Email is already used")
          };
        }

        let formData = new FormData(event.target);
        let form = {};
        for (let pair of formData.entries()) {
          form[pair[0]] = pair[1];
        }

        form.status = this.isActive ? 1 : 0;
        form.notificationType = this.formData.bookingNotif;

        let data = { form: form, id: this.formData.id };
        let result = await this.$store.dispatch("patchEmailNotification", data);
        if (result.data.data) {
          await this.$toastr.success("Your changes are saved", "Success");
          await this.$store.dispatch("fetchEmailNotification");
          this.$emit("close");
        }
      } catch (error) {
        const errType = error.type || "error";
        const errTitle = error.title || "Error";
        const errMsg = error.error.message || error.message;

        this.$toastr[errType](errMsg, errTitle);
      } finally {
        this.loader = false;
      }
    },
    handleSwitchClick() {
      this.isActive = !this.isActive;
    },
    editSelectedEmailNotif() {
      if (this.formData.id) {
        this.isActive = this.user.status == 1 ? true : false;
        for (let pair in this.user.notificationType) {
          this.formData.bookingNotif[pair] = this.user.notificationType[pair];
        }
      }
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  font-family: "Gotham", sans-serif;
  font-size: $font-size-xs;
  margin-bottom: 0;
}
</style>
